import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './assets/css/global.css'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import 'moment'
import 'moment-timezone'
import 'animate.css'
import ECharts from 'vue-echarts'
import VueCoreVideoPlayer from 'vue-core-video-player'

// Componet to video
// https://core-player.github.io/vue-core-video-player/configuration.html
// https://cloudconvert.com/mov-to-webm
Vue.use(VueCoreVideoPlayer)


// register globally (or you can do it locally)
Vue.component('v-chart', ECharts)

// Vue.prototype.$srcPropiedades = {}

Vue.prototype.$srcPropiedades = Vue.observable({
  data: []
})
Vue.prototype.$page = Vue.observable({
  number: 1
})
Vue.prototype.$taskAlert = Vue.observable({
  alert: true
})
Vue.prototype.$task = Vue.observable({
  task: [],
  cant: []
})
Vue.prototype.$user = Vue.observable({
  special_day: true,
  hidden_menu: true,
  avatar: false,
  avatar_list: ['avatar_0','avatar_1', 'avatar_2', 'avatar_3', 'avatar_4', 'avatar_5', 'avatar_6', 'avatar_7', 'avatar_8', 'avatar_9', 'avatar_10', 'avatar_11', 'avatar_12', 'avatar_13', 'avatar_14', 'avatar_15', 'avatar_16', 'avatar_17', 'avatar_18', 'avatar_19', 'avatar_20'],
  src_avatar: ''
})

Vue.prototype.$devs = Vue.observable({
  status: false,
  version: "2.1"
})

Vue.config.productionTip = false


new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
